import { useNavigate } from "react-router-dom";

import { EditOrderContactForm } from "../components/edit-order-contact-form";
import { Header } from "../components/header-demo";
import { useExistingOrderContext } from "../contexts/existing-order.context";
import routes from "../routes";

export function EditOrderContactPage() {
  const order = useExistingOrderContext();
  const navigate = useNavigate();

  return (
    <main className="max-w-md mx-auto p-2 space-y-2">
      <Header title="Modifier vos coordonnées" backUrl={routes.edit} />
      <EditOrderContactForm
        order={order}
        onEdit={() => navigate(routes.edit)}
      />
    </main>
  );
}
